(() => {
  'use strict';
  const bind = (root = document) => {
    root.querySelectorAll('[data-color-zoom]').forEach(button => {
      if (button.dataset.zoomBound) return;
      button.dataset.zoomBound = 'true';
      button.addEventListener('click', () => {
        const source = button.querySelector('img');
        const dialog = document.querySelector('[data-color-zoom-dialog]');
        if (!source || !dialog) return;
        const target = dialog.querySelector('[data-color-zoom-image]');
        const romanDetail = Boolean(button.closest('[data-roman-gallery][data-small-detail]'));
        dialog.classList.toggle('roman-detail-zoom', romanDetail);
        target.src = button.closest('[data-roman-gallery]') ? source.src : (source.currentSrc || source.src);
        target.alt = source.alt;
        dialog.querySelector('[data-color-zoom-caption]').textContent = source.alt;
        dialog.showModal();
      });
    });
  };
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
